import React from 'react';

const ServiceItem = ({title, url }) => (
  <li key={title} className="service--list--item">
    <a href={url} className="button button__submit">{title}</a>
  </li>
);

export default ServiceItem;
